<template>
  <div class="p-4">
    <button @click="createNewAttributeGroup" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 rounded">
      New Attribute Group
    </button>
    <el-table
      :data="groups"
      :empty-text="'No Attributes Groups available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name">
      </el-table-column>
      <el-table-column
        align="center"
        label="Operations">
        <template slot-scope="scope">
          <el-button @click="updateGroup(scope.row)" type="text" size="small">
            <i class="text-sm el-icon-edit mr-1"></i>
          </el-button>
          <el-button @click="deleteGroup(scope.row.id)" type="text" size="small">
            <i class="text-sm text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <CreateForm />
    <UpdateForm />
  </div>
</template>

<script>
import CreateForm from './_includes/CreateForm.vue';
import UpdateForm from './_includes/UpdateForm.vue';

export default {
  name: 'AttributeGroup',
  components: {
    CreateForm,
    UpdateForm,
  },
  computed: {
    groups() {
      return this.$store.state.InventoryModule.Attributes.groups;
    },
  },
  methods: {
    createNewAttributeGroup() {
      this.$modal.show('new-attributes-group');
    },
    async updateGroup(group) {
      await this.$store.commit('InventoryModule/Attributes/setCurrentSelected', { property: 'group', payload: group });
      this.$modal.show('update-attributes-group');
    },

    async deleteGroup(groupId) {
      this.$confirm('This will permanently delete the Group and all attributes under it. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Attributes/deleteAttributeGroup', groupId);
          this.$notify.success({
            title: 'Success',
            message: 'Group successfully deleted',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>
